import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MetricLocalization } from '@/features/LocalizationHeaderDropdown/types';
import { initialState } from './initialState';

export const metricLocalizationSlice = createSlice({
  name: 'metricLocalization',
  initialState,
  reducers: {
    setCurrentMetricLocalization: (state, action: PayloadAction<MetricLocalization>) => {
      state.metricLocalization = action.payload;
    },
  },
});

export const { 
  setCurrentMetricLocalization 
} = metricLocalizationSlice.actions;
export default metricLocalizationSlice.reducer;
